import { ApolloLink } from "@apollo/client";
function replaceKeyValueInObject(obj, replacements) {
    if (typeof obj !== "object" || obj === null)
        return;
    for (const key in obj) {
        if (replacements.hasOwnProperty(key)) {
            obj[key] = replacements[key];
        }
        if (typeof obj[key] === "object") {
            replaceKeyValueInObject(obj[key], replacements);
        }
    }
}
/**
 * This is a anti-feature and should not be used.
 * Overwrites the variables of a GraphQL operation with provided values.
 */
export const queryVariableOverwritesLink = (replacements = {}) => new ApolloLink((operation, forward) => {
    replaceKeyValueInObject(operation.variables, replacements);
    return forward(operation);
});
//# sourceMappingURL=queryVariableOverwrites.js.map